var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GoodsPreview',{attrs:{"picList":_vm.itemDetail.project.realisticImgs || [],"itemDetail":_vm.itemDetail}})}
var staticRenderFns = []

export { render, staticRenderFns }